<template>
  <v-row>
    <v-col>
      <v-card class="mx-auto" :loading="loading" max-width="300">
        <v-list>
          <v-subheader>Downloads</v-subheader>
          <v-list-item-group color="primary">
            <v-list-item
              v-for="(document, i) in documents"
              :key="i"
              @click="openUrl(document.id)"
            >
              <v-list-item-content>
                <v-list-item-title v-text="document.filename"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/functions'

export default {
  data() {
    return {
      loading: true,
      documents: null
    }
  },
  methods: {
    openUrl(id) {
      if(id == 0) { return }
      const vm = this
      vm.loading = true
      // opening window before fetching url solves mobile blocking new window as a popup
      const newWindow = window.open()
      const getDoc = firebase.functions().httpsCallable('getDocumentUrl')
      getDoc({id: id})
      .then(function(response) {
        // window.open(response.data.result.url, '_blank')
        newWindow.location.href = response.data.result.url
        vm.loading = false
      })
    }
  },
  mounted() {
    const vm = this
    const id = vm.$store.state.assignment
    const getOpusApi = firebase.functions().httpsCallable('getOpusApi')

    getOpusApi({
      table: `vendor_assignments/${id}`,
      params: {
        include: 'documents,event_documents'
      }
    }).then(function(response) {
      // console.log(response.data.result)
      if(response.data.result.documents == undefined && response.data.result.event_documents == undefined) {
        vm.documents = [{filename: 'No documents to display', id: 0}]
      }
      else {
        vm.documents = response.data.result.documents == undefined ? response.data.result.event_documents : response.data.result.documents
      }
      vm.loading = false
    })
  }
}
</script>